import { type BrowserConfig, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

// Escapes regex metacharacters (e.g. the `.` in a hostname) so the origin is matched
// literally rather than as a pattern.
const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Anchors on both ends: matches the origin exactly, followed by either the start of a path
// (`/`) or nothing. Without the trailing anchor, an entry for `https://api.example.com` would
// also match `https://api.example.com.evil.example/` (attacker-controlled subdomain suffix) or
// `https://api.example.com:8443` (a different port, i.e. a different origin).
const originRegExp = (url: string): RegExp =>
  new RegExp(`^${escapeRegExp(new URL(url).origin)}(?:/|$)`);

/**
 * Configuration object to be passed to `initializeFaro` on app startup.
 */
export const faroConfig: BrowserConfig = {
  url: import.meta.env.VITE_FARO_URL,
  app: {
    name: 'labeling-web',
    environment: `labeling-web-${import.meta.env.MODE}`,
  },
  experimental: {
    trackNavigation: true, // reports SPA route changes (e.g. React Router) as navigation spans
  },
  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation({
      instrumentationOptions: {
        propagateTraceHeaderCorsUrls: [
          originRegExp(import.meta.env.VITE_API_BASE_URL),
          originRegExp(import.meta.env.VITE_ASSISTANT_BASE_URL),
        ],
      },
    }),
  ],
};
